import React from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
import ToggleButton from './ToggleButton';

const useStyles = createUseStyles((theme) => ({
  menuItem: {
    composes: 'flexRow',
  },
  vertical: {
    composes: 'flexColumn',
  },
  list: {
    listStyle: 'none',
  },
  label: {
    marginRight: theme.spacing(1),
    textTransform: 'capitalize',
  },
  value: {
    fontWeight: 600,
  },
  labelClassName: {
    composes: 'flexRow spaceBetween',
  },
  iconButton: {
    width: 14,
    cursor: 'pointer',
  },
  icon: {
    width: '100%',
    transition: 'transform 0.5s'
  },
  openIcon: {
    transform: 'rotate(180deg)',
  },
  title: {
    '& span:first-child': {
      fontWeight: 'normal',
    },
  }
}));

const MenuItem = ({ 
  text, 
  label, 
  className, 
  component,
  customValue,
  vertical = false,
  onClick,
  labelClassName,
  open,
}) => {
  const classes = useStyles();

  if (!text) return null;

  const Component = component || 'li';

  return (
    <Component 
      className={clsx(
        classes.menuItem,
        className, 
        !component && classes.list,
        vertical && classes.vertical,
        component && component.startsWith('h') && classes.title,
      )}
    >
      <div className={clsx(classes.labelClassName, labelClassName)}>
        {/* ------------------------------------------------ */}
        {/* --------------------- Label -------------------- */}
        {/* ------------------------------------------------ */}
        {label && (
          <span className={classes.label}>
            {`${label} `} 
          </span>
        )}

        {/* ------------------------------------------------ */}
        {/* --------------------- Icon --------------------- */}
        {/* ------------------------------------------------ */}
        <ToggleButton onClick={onClick} open={open} />    
      </div>

      {/* ------------------------------------------------ */}
      {/* --------------------- value -------------------- */}
      {/* ------------------------------------------------ */}
      <span className={classes.value}>
        {!customValue ? text.raw : customValue}
      </span>

    </Component>      
  );
}

export default MenuItem;